import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable()
export class LoaderService {
  private loaderSubject = new BehaviorSubject<boolean>(false);
  private stop$ = new Subject<void>();
  loaderState$ = this.loaderSubject.asObservable().pipe(takeUntil(this.stop$));

  stop() {
    this.stop$.next();
    this.stop$.complete();
  }

  show(): void {
    this.loaderSubject.next(true);
  }

  hide(): void {
    this.loaderSubject.next(false);
  }
}
